export default __webpack_public_path__ + "static/strallen-90074f955dfe254775c09c15c1671e7b.jpg";